import { FlaskConical } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const DemoBadge = () => {
  const { user, shop } = useAuth();
  if (!user || shop?.kind !== "demo") return null;
  return (
    <div
      data-testid="demo-data-badge"
      className="sticky top-0 z-50 border-b border-[#E9C98B]/40 bg-[#1A160D]/90 text-[#F3DDAE] backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-start sm:items-center gap-2 px-5 py-1.5 text-xs sm:px-8 sm:text-sm">
        <FlaskConical className="h-4 w-4 shrink-0" />
        <span className="font-semibold">Demo data</span>
        <span className="text-[#F3DDAE]/80">
          — {shop.name} is a simulated sample shop. Nothing here is real Etsy data.
        </span>
      </div>
    </div>
  );
};
